import { render, staticRenderFns } from "./SummaryPanel.vue?vue&type=template&id=db0fa1e4&scoped=true&"
import script from "./SummaryPanel.vue?vue&type=script&lang=ts&"
export * from "./SummaryPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryPanel.vue?vue&type=style&index=0&id=db0fa1e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0fa1e4",
  null
  
)

export default component.exports